import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, BoxExtendedProps, RoundCloseIcon, Text, useResponsive, WarningCard } from '@common-fe/common-fe';

import { ReviewAddressModal } from '@/modules/core/components/BadAddressBanner';
import { useBadAddressReviewStore } from '@/modules/core/components/BadAddressBanner/stores/useBadAddressReview.store';

interface Props extends BoxExtendedProps {
  storeKey: string;
  showWarning?: boolean;
}

const FixYourAddressWarningCard: React.FC<Props> = ({ storeKey, showWarning, ...props }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const { handleOpenModal } = useBadAddressReviewStore(storeKey);

  return (
    <>
      {showWarning ? (
        <WarningCard
          testId="fix-your-address"
          icon={<RoundCloseIcon size="20px" color="danger" />}
          title={<Text weight={700}>{t('Fix your address or payment method')}</Text>}
          description={t(
            'Mail sent to your address was returned as undeliverable. Since your current payment method is check, please update your details to submit this claim.'
          )}
          backgroundColor="dangerContainer"
          borderColor="transparent"
          topBorderColor="transparent"
          containerProps={{ pad: 'spacing16' }}
          border={undefined}
          {...props}
        >
          <Box margin={{ top: 'spacing12' }}>
            <AppButton
              testId="fix-your-address_button"
              width={isMobile ? '100%' : undefined}
              onClick={handleOpenModal}
            >
              {t('Review Address')}
            </AppButton>
          </Box>
        </WarningCard>
      ): null}

      <ReviewAddressModal storeKey={storeKey} />
    </>
  );
};

export default FixYourAddressWarningCard;
